import { ethers } from "ethers";
import { useEffect, useState } from "react";
import governorAbi from "../Populus/Populus.json";
import { Link } from "react-router-dom";
const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
function Proposals(props) {
  const contractAddress = "0x93681566B63659db5dacB9FdC3c8934Ae8fcDEcB";
  const [events, setEvents] = useState();

  const provider = new ethers.providers.AlchemyProvider(
    "matic",
    "_8TZHcd_cqmy0KNW3bQuBEDWhnnRIzg5"
  );
  useEffect(() => {
    async function getProposals() {
      console.log("provider", provider);

      const contract = new ethers.Contract(
        contractAddress,
        governorAbi,
        provider
      );
      console.log("contract", contract);

      const filter = contract.filters.ProposalCreated();
      const iface = new ethers.utils.Interface(governorAbi);
      const logs = await contract.queryFilter(filter);
      console.log("logs", logs);

      const parsedLogs = structuredClone(
        logs.map((log) => iface.parseLog(log))
      );
      for (var i = 0; i < parsedLogs.length; i++) {
        console.log("args", parsedLogs[i].args);
        var currentBlock = await parseInt(
          parsedLogs[i].args.startBlock._hex,
          16
        );
        console.log("currentBlock", currentBlock);
        parsedLogs[i].args.startTime = await getTime(currentBlock);
      }
      console.log("parsedLogs", parsedLogs);
      setEvents(parsedLogs);
    }
    getProposals();
    // eslint-disable-next-line
  }, []);

  function formatTime(timestamp) {
    var d = new Date(timestamp);
    var time =
      d.getDate() +
      " " +
      MONTHS[d.getMonth()] +
      " " +
      d.getFullYear() +
      " " +
      d.getHours() +
      ":" +
      d.getMinutes();
    return time;
  }

  const getTime = async (blockNumber) => {
    console.log("blocknum", blockNumber);
    const timestamp = await provider.getBlock(blockNumber);
    console.log("timestamp", timestamp.timestamp);
    const returnVal = await formatTime(timestamp.timestamp * 1000);
    return returnVal;
  };
  return (
    <div className="widgetStyling">
      {events
        ?.slice(0)
        .reverse()
        .map((event, i) => (
          <>
            <div key={i} className="statisticSubBox relative">
              <div className="proposalDivInner">
              <div className="proposalTimeDiv">
                  <p className="standardBoldText darkMaroonText"> {event?.args?.startTime}</p>
                </div>
                <p className="topSubtitle darkMaroonText">
                  CIR {events.length - i - 1}
                </p>
                <Link
                  className="noDecoration"
                  to={"proposal/" + String(events.length - i - 1)}
                >
                  <h1 className="titleMain marginBottom darkMaroonText">
                    {event?.args?.description.split("~~ENDTITLE~~")[0]}{" "}
                  </h1>
                </Link>
                <p>
                  {event?.args?.description.split("~~ENDTITLE~~")[1]}
                </p>
                <br/>
                <p className="smallText darkMaroonText">
                  Proposed by: {event?.args?.proposer.slice(0, 4)}...
                  {event?.args?.proposer.slice(38, 42)}
                </p>
              </div>
            </div>
            <br />
          </>
        ))}
    </div>
  );
}

export default Proposals;
